import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import * as ROUTES from '../../constants/routes';
import {AuthUserContext, UserContext, CompanyContext, BranchContext, AccessContext} from '../Session/context';
import { withFirebase } from '../Firebase';

const withAuthorization = (condition,routefail=ROUTES.SIGN_IN) => Component => {
    class WithAuthorization extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                authUser:null,

                currentUser:null,
                currentCompany:null,
                currentBranch:null,
                
                ready:false,
                
                rejected: null,
                errorPosition:"",

                accesses:null,
            };
        }

        componentDidMount() {
            
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if (!condition(authUser)) {
                        if (routefail){//if param=false => skip sll redirect
                            this.props.history.push(routefail)
                        }
                    }else{
                        //accepted enter page
                        this.setState({authUser:authUser})
                        if(!!this.listenerUserObject ) {this.listenerUserObject()}
                        if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                        if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                        if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}

                        if(!authUser){
                            this.setState({
                                currentUser:null,
                                currentCompany:null,
                                currentBranch:null,
                                accesses:null,
                                
                                ready:false,
                            })
                            return
                        }
                        
                        this.listenerUserObject= this.props.firebase.fs.doc("users/"+authUser.uid).onSnapshot((userDoc) => {
                        
                            if (userDoc.exists) {
                              
                              this.setState({
                                currentUser:userDoc.data(),
                              })

                              if(userDoc.data().companyId!=="" && userDoc.data().branchId!==""&&
                                !!this.state.currentCompany&&userDoc.data().companyId===this.state.currentCompany.id &&
                                !!this.state.currentBranch&&userDoc.data().branchId===this.state.currentBranch.id)
                              {
                                //skip unregister
                              }else{
                                if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}

                              if(userDoc.data().companyId!=="" && userDoc.data().branchId!==""){
                                    //get all data here
                                    this.listenerCompanyObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId).onSnapshot((companyDoc) => {
                                        if (companyDoc.exists) {
                                          this.setState({
                                            currentCompany:companyDoc.data(),
                                          })
                                        }else{
                                            this.setState({
                                                currentUser:userDoc.data(),
                                                currentCompany:null,
                                                currentBranch:null,
                                                accesses:null,
                                            })
                                        }
                                        isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerCompanyObject"})
                                    })
                                    
                                    this.listenerBranchObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId+"/branches/"+userDoc.data().branchId).onSnapshot((branchDoc) => {
                                      if (branchDoc.exists) {
                                        this.setState({
                                          currentBranch:branchDoc.data(),
                                        })
                                      }else{
                                          this.setState({
                                              currentUser:userDoc.data(),
                                              currentCompany:null,
                                              currentBranch:null,
                                              accesses:null,
                                          })
                                      }
                                      isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerBranchObject"})
                                    })
                                    
                                    this.listenerEmployeeDataObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyId+"/branches/"+userDoc.data().branchId+"/employeeData/"+authUser.uid).onSnapshot((employeeDataDoc) => {
                                        if(employeeDataDoc.exists){
                                            this.setState({
                                                accesses:employeeDataDoc.data().accessList,
                                            })
                                        }else{
                                            this.setState({
                                                currentUser:userDoc.data(),
                                                currentCompany:null,
                                                currentBranch:null,
                                                accesses:null,
                                            })
                                        }
                                        isReady(this)
                                    },(e)=>{
                                        this.setState({rejected:e,errorPosition:"listenerEmployeeDataObject"})
                                    })

                                }else{
                                  if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                  if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                  if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                  //resign
                                  this.setState({
                                      currentUser:userDoc.data(),
                                      currentCompany:null,
                                      currentBranch:null,
                                      accesses:null,
                                  })
                                }
                              }
                            }else{
                                if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                //new account here
                                this.setState({
                                    currentUser:null,
                                    currentCompany:null,
                                    currentBranch:null,
                                    accesses:null,
                                })
                            }
                            isReady(this)
                        },(e)=>{
                            this.setState({rejected:e,errorPosition:"listenerUserObject"})
                        })
                    }
                },
            );
            
        }


        componentWillUnmount() {
            this.listener();
            if(!!this.listenerUserObject ) {this.listenerUserObject()}
            if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
            if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
            if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
        }
  
        render() {
            return (
                <AuthUserContext.Consumer>
                {(authUser) =>{
                    return condition(authUser) ?
                        <UserContext.Provider value={this.state.currentUser}>
                            <CompanyContext.Provider value={this.state.currentCompany}>
                                <BranchContext.Provider value={this.state.currentBranch}>
                                    <AccessContext.Provider value={this.state.accesses}>
                                      <Component authUser={authUser} rejected={this.state.rejected} errorPosition={this.state.errorPosition} {...this.props} />
                                    </AccessContext.Provider>
                                </BranchContext.Provider>
                            </CompanyContext.Provider>
                        </UserContext.Provider>
                    :
                      !!authUser?
                        null
                      :
                        routefail?
                          <div>Loading...</div>
                        :
                          <div>Preview Not Available<br /><span>You dont have any access</span></div>
                    }
                }
                </AuthUserContext.Consumer>
            )
        }
    }

    function isReady(context){
        if(context.state.ready){
            return true
        }else{
            if(!!context.state.currentUser&&!!context.state.currentCompany&&!!context.state.currentBranch&&!!context.state.accesses){
                context.setState({ready:true})
                return true
            }
            return false
        }
    }

    return compose(
        withRouter,
        withFirebase,
    )(WithAuthorization);
};

export default withAuthorization;